export default {
  scene: {
    background: 0xfaecc5,
    shadow: 0x88909c,
    fog: {
      color: 0xfaecc5,
      near: 50,
      far: 200
    }
  },
  snow: {
    count: 2000,
    width: 100,
    height: 100,
    depth: 100,
    wind: {
      speed: 5,
      rotation: Math.PI
    },
    position: {
      x: 0,
      y: 45,
      z: 0
    }
  },
  environment: {
    rotation: Math.PI / 2,
    position: {
      x: 0,
      y: -5.1,
      z: 0
    }
  },
  character: {
    timeScale: 1.0,
    rotation: Math.PI / 2,
    position: {
      x: -14,
      y: -5,
      z: 5
    }
  },
  player: {
    timeScale: 1.1,
    rotation: Math.PI / 2,
    position: {
      x: -12,
      y: -5,
      z: -1
    }
  },
  speed: 3
}
